export interface IStatusLookup {
    name: string;
    values: string[];
}

export const userRequestStatusLookup: IStatusLookup[] = [{
    name: "DRAFT",
    values: ["DRAFT"],
}, {
    name: "SUBMITTED",
    values: ["SUBMITTED", "TO_REVIEW"],
}, {
    name: "TO_MODIFY",
    values: ["TO_MODIFY"],
}, {
    name: "REJECTED",
    values: ["REJECTED"],
}, {
    name: "VALIDATED",
    values: ["VALIDATED"],
}, {
    name: "MIXED",
    values: ["MIXED"],
}, {
    name: "ASSESSED",
    values: ["ASSESSED"],
}, {
    name: "CANCELED",
    values: ["CANCELED"],
}];

export const vipRequestStatusLookup: IStatusLookup[] = [{
    name: "TO_REVIEW",
    values: ["TO_REVIEW"],
}, {
    name: "REJECTED",
    values: ["REJECTED"],
}, {
    name: "VALIDATED",
    values: ["VALIDATED"],
}, {
    name: "MIXED",
    values: ["MIXED"],
}, {
    name: "ASSESSED",
    values: ["ASSESSED"],
}, {
    name: "CANCELED",
    values: ["CANCELED"],
}];

export const adminRequestStatusLookup: IStatusLookup[] = [{
    name: "DRAFT",
    values: ["DRAFT"],
}, {
    name: "SUBMITTED",
    values: ["SUBMITTED"],
}, {
    name: "TO_MODIFY",
    values: ["TO_MODIFY"],
}, {
    name: "TO_REVIEW",
    values: ["TO_REVIEW"],
}, {
    name: "REJECTED",
    values: ["REJECTED"],
}, {
    name: "VALIDATED",
    values: ["VALIDATED"],
}, {
    name: "MIXED",
    values: ["MIXED"],
}, {
    name: "ASSESSED",
    values: ["ASSESSED"],
}, {
    name: "CANCELED",
    values: ["CANCELED"],
}];
